export enum DoorThickness {
  _138 = '1 3/8" (35mm)',
  _134 = '1 3/4" (45mm)',
}
